// Convert any string to a URL-friendly slug
// "Food and Health" → "food-and-health"
// "Best Foods for You!" → "best-foods-for-you"
export function toSlug(str = '') {
  return String(str)
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');
}

// Build a combined title+id slug: "best-foods-for-you--5466b00a-39cf-46fc-81e1"
// Double dash (--) separates the readable title from the ID.
// The title portion is capped so URLs stay a sane length for SEO and so the
// on-disk path during prerender never exceeds the OS path limit (Windows ~260).
const MAX_TITLE_SLUG_LEN = 60;
export function buildSlug(title, id) {
  const titleSlug = toSlug(title).slice(0, MAX_TITLE_SLUG_LEN).replace(/-+$/, '');
  return `${titleSlug}--${id}`;
}

// Extract the original ID from a combined slug.
//
// The ID always comes after the FINAL "--". Use lastIndexOf (not indexOf) so
// this stays correct when the title portion itself contains "--" — which
// happens for titles with " - ", " | " or ":". An ID never contains "--", so
// the last "--" is always the real separator.
export function extractIdFromSlug(slug = '') {
  const separatorIndex = String(slug).lastIndexOf('--');
  if (separatorIndex !== -1) return slug.slice(separatorIndex + 2);
  return slug;
}

// Category slug ↔ display name mapping. Derived from the category list so a
// new category only has to be added in one place (constants/blogCategories.js).
import { ALL_CATEGORIES } from '../constants/blogCategories';

const SLUG_TO_CATEGORY = ALL_CATEGORIES.reduce((acc, name) => {
  acc[toSlug(name)] = name;
  return acc;
}, {});

export function categoryFromSlug(slug = '') {
  return SLUG_TO_CATEGORY[String(slug).toLowerCase()] || slug;
}

export function isKnownCategorySlug(slug = '') {
  return Object.prototype.hasOwnProperty.call(SLUG_TO_CATEGORY, String(slug).toLowerCase());
}

// Canonical public path for a blog: /blog/<category-slug>/<title>--<id>
export function blogPath(blog) {
  if (!blog) return '/blogs';
  const id = blog.blogId || blog.id || blog._id;
  return `/blog/${toSlug(blog.category || 'Others')}/${buildSlug(blog.title, id)}`;
}
